import { Helpers } from "./helpers/helpers";

export class BackToTop
{

	constructor() {
		const secondSection = document.querySelector('.main-content section:nth-of-type(2)') as HTMLElement;
		const backToTop = document.querySelector('.explore') as HTMLElement;

		if (backToTop) {
			backToTop.addEventListener('click',
				() => {

					let location = 0;
					if (!backToTop.classList.contains('past-hero')) {
						location = secondSection.getBoundingClientRect().top;
					
					}
			
					Helpers.scrollTo(location, 400);
				});
		}

	}


}